export default __webpack_public_path__ + "static/architecture-330541e9aa7947e4ff0af55bda955450.png";